import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CardRegenerateFiltering } from './Pages';

export const CardRegenerateRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CardRegenerateFiltering} />
    </Fragment>
)